import { useAtomValue } from "jotai";
import { useAtomCallback } from "jotai/utils";
import { useCallback } from "react";
import { useShareWhiteboardCallback } from "../../components/whiteboard/useShareWhiteboardCallback";
import { participantCountAtom } from "../../video-sdk";
import { isWhiteboardModeAtom } from "../messages/state";
import { useSessionModeCallbacks } from "./useSessionModeCallbacks";

export function useWhiteboardControl() {
  const canWhiteboard = !!useAtomValue(participantCountAtom);
  const [startWhiteboarding, { isLoading }] = useShareWhiteboardCallback();
  const { stopCurrentMode: stopWhiteboarding } = useSessionModeCallbacks();
  const isWhiteboardMode = useAtomValue(isWhiteboardModeAtom).value;
  const getIsWhiteboarding = useAtomCallback(
    useCallback((get) => get(isWhiteboardModeAtom).value, []),
  );

  const toggleWhiteboard = useCallback(() => {
    if (getIsWhiteboarding()) {
      stopWhiteboarding();
    } else {
      startWhiteboarding();
    }
  }, [getIsWhiteboarding, startWhiteboarding, stopWhiteboarding]);

  return {
    canWhiteboard,
    isLoading,
    isWhiteboardMode,
    toggleWhiteboard,
  };
}
